import React, { useEffect, useMemo } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";

import { WEB_ROUTES } from "./constants";

import ProtectedLayout from "./Components/Layouts/ProtectedLayout";

import ProtectedRoute from "./Components/Routes/ProtectedRoute";
import PublicRoute from "./Components/Routes/PublicRoute";

import { baseRoute } from "./Helper";
import Account from "./Pages/Account";
import CreateQuiz from "./Pages/CreateQuiz";
import Game from "./Pages/Game";
import Home from "./Pages/Home";
import LeaderBoard from "./Pages/LeaderBoard";
import QuizHistory from "./Pages/QuestionHistory";
import Quiz from "./Pages/Quiz";
import QuizGame from "./Pages/QuizGame";
import QuestionHistory from "./Pages/QuizHistory";
import TutorialLogin from "./Pages/TutorialLogin";
import QuestionDetails from "./Pages/QuestionDetails/QuestionDetails";
import UpadateQuestionDetails from "./Pages/UpdateQuestionDetails/QuestionDetails";
import UpdateQuiz from "./Pages/UpdateQuiz";
import EditQuiz from "./Pages/EditQuiz";

function App() {
  const ROUTES = useMemo(
    () => [
      { path: WEB_ROUTES.ACCOUNT, element: <Account />, isPublic: true },
      // { path: WEB_ROUTES.HOME, element: <Home /> },
      { path: WEB_ROUTES.HOME, element: <Quiz />, isBack: true, isPermanentClose: true },
      { path: WEB_ROUTES.QUIZ_GAME, element: <QuizGame />, isNavbar: false },
      { path: WEB_ROUTES.CREATE_QUIZ, element: <CreateQuiz />, isBack: true },
      { path: WEB_ROUTES.EDIT_QUIZ(), element: <EditQuiz />, isBack: true },
      { path: WEB_ROUTES.UPDATE_QUIZ, element: <UpdateQuiz />, isBack: true },
      { path: WEB_ROUTES.GAME, element: <Game />, isNotWrap: true },
      { path: WEB_ROUTES.QUIZ_HISTORY, element: <QuizHistory />, isBack: true },
      { path: WEB_ROUTES.QUESTION_HISTORY, element: <QuestionHistory />, isBack: true },
      { path: WEB_ROUTES.ADD_QUESTION, element: <QuestionDetails />, isBack: true },
      { path: WEB_ROUTES.UPDATE_QUESTION, element: <UpadateQuestionDetails />, isBack: true },
      { path: WEB_ROUTES.LEADER_BOARD, element: <LeaderBoard />, isNavbar: false, isBack: true },
      { path: WEB_ROUTES.TUTORIAL_LOGIN, element: <TutorialLogin />, isNavbar: false, isBack: true },
    ],
    []
  );

  // useEffect(() => {
  //   const setVH = () => {
  //     const vh = window.innerHeight * 0.01;
  //     document.documentElement.style.setProperty('--vh', `${vh}px`);
  //   };
  //   window.addEventListener('resize', setVH);
  //   setVH();

  //   return () => {
  //     window.removeEventListener('resize', setVH)
  //   }
  // }, [])

  return (
    <Router>
      <Routes>
        {ROUTES.map(({ path, element, isNotWrap, isPublic, isNavbar, isBack, isPermanentClose }, index) => (
          <Route
            key={index}
            exact
            path={baseRoute(path)}
            element={
              isNotWrap ? element :
                isPublic ? (
                  <PublicRoute>{element}</PublicRoute>
                ) : (
                  <ProtectedRoute>
                    <ProtectedLayout isNavbar={isNavbar} isBack={isBack} isPermanentClose={isPermanentClose || false}>{element}</ProtectedLayout>
                  </ProtectedRoute>
                )
            }
          />
        ))}
        <Route
          path={"*"}
          element={<Navigate to={baseRoute(WEB_ROUTES.ACCOUNT)} />}
        />
      </Routes>
    </Router>
  );
}
export default App;
